import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CursorGlow from './components/CursorGlow';
import ScrollToHash from './components/ScrollToHash';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ShippingPolicy from './pages/ShippingPolicy';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <CursorGlow />
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/shipping-policy" element={<ShippingPolicy />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
